export const GET_ALL_EVENTS = 'GET_ALL_EVENTS';
export const SET_USER_HAS_EVENTS_WITH_PRICING = 'SET_USER_HAS_EVENTS_WITH_PRICING';
export const GET_EVENT_BY_ID = 'GET_EVENT_BY_ID';
export const CREATE_EVENT = 'CREATE_EVENT';
export const DESELECT_EVENT = 'DESELECT_EVENT';
export const RESET_CREATED_EVENT = 'RESET_CREATED_EVENT';
export const UPDATE_EVENT = 'UPDATE_EVENT';
export const RESET_UPDATED_EVENT = 'RESET_UPDATED_EVENT';
export const ANNOUNCE_EVENT_COMPLETE = 'ANNOUNCE_EVENT_COMPLETE';
export const SET_PUBLIC_GALLERY = 'SET_PUBLIC_GALLERY';
export const LOADING_PUBLIC_GALLERY = 'LOADING_PUBLIC_GALLERY';
export const DELETE_EVENT = 'DELETE_EVENT';
export const RESET_DELETED_EVENT = 'RESET_DELETED_EVENT';
export const GET_SHARED_WITH = 'GET_SHARED_WITH';
export const GET_EVENT_SHARED_WITH_ME = 'GET_EVENT_SHARED_WITH_ME';
export const LOADING_EVENT = 'LOADING_EVENT';
export const LOADING_SHARED_WITH_ME = 'LOADING_SHARED_WITH_ME';

export const GET_ALL_FTP_USERS_BY_EVENT_ID = 'GET_ALL_FTP_USERS_BY_EVENT';
export const CLEAN_FTP_USERS = 'CLEAN_FTP_USERS';
export const CREATE_FTP_USER = 'CREATE_FTP_USER';

export const GET_STATS_BY_EVENT_ID = 'GET_STATS_BY_EVENT_ID';
export const GET_NUMBER_OF_DELIVERED_PHOTOS = 'GET_NUMBER_OF_DELIVERED_PHOTOS';
export const GET_NUMBER_OF_INDEXES_FACES = 'GET_NUMBER_OF_INDEXES_FACES';
export const GET_NUMBER_OF_PHOTOS = 'GET_NUMBER_OF_PHOTOS';
export const GET_NUMBER_OF_SELFIES = 'GET_NUMBER_OF_SELFIES';
export const GET_NUMBER_OF_USERS_ACCESS_BY_CODE = 'GET_NUMBER_OF_USERS_ACCESS_BY_CODE';
export const GET_NUMBER_OF_USERS_WITH_MATCH = 'GET_NUMBER_OF_USERS_WITH_MATCH';
export const GET_NUMBER_OF_GLOBAL_MATCHES = 'GET_NUMBER_OF_GLOBAL_MATCHES';
export const GET_NUMBER_OF_UNIQUES_SHARES_BY_EVENT = 'GET_NUMBER_OF_UNIQUES_SHARES_BY_EVENT';
export const GET_NUMBER_OF_UNIQUES_VIEWS_BY_EVENT = 'GET_NUMBER_OF_UNIQUES_VIEWS_BY_EVENT';
export const GET_NUMBER_OF_GLOBAL_VIEWS_BY_EVENT = 'GET_NUMBER_OF_GLOBAL_VIEWS_BY_EVENT';
export const GET_PHOTOS_BY_USER = 'GET_PHOTOS_BY_USER';
export const GET_ORDERS_AMOUNT = 'GET_ORDERS_AMOUNT';
export const GET_NUMBER_OF_ORDERS = 'GET_NUMBER_OF_ORDERS';
export const GET_NUMBER_OF_PACK_ORDERS = 'GET_NUMBER_OF_PACK_ORDERS';
export const GET_TOTAL_AMOUNT_ORDERS = 'GET_TOTAL_AMOUNT_ORDERS';
export const GET_TOTAL_AMOUNT_PACK_ORDERS = 'GET_TOTAL_AMOUNT_PACK_ORDERS';
export const GET_SOLD_PHOTOS = 'GET_SOLD_PHOTOS';
export const GET_SOLD_PACKS_AMOUNT = 'GET_SOLD_PACKS_AMOUNT';
export const CLEAN_EVENT_STATS = 'CLEAN_EVENT_STATS';
export const LOADING_STATS = 'LOADING_STATS';

export const SIGN_OUT = 'SIGN_OUT';
export const SIGN_IN = 'SIGN_IN';
export const SIGN_UP = 'SIGN_UP';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const SIGN_IN_ERROR = 'SIGN_IN_ERROR';
export const SIGN_UP_ERROR = 'SIGN_UP_ERROR';
export const RESET_SIGN_IN_ERROR_MESSAGE = '';
export const LOADING_USER = 'LOADING_USER';
export const GET_USER = 'GET_USER';
export const POST_USER = 'POST_USER';
export const GET_USER_FAILED = 'GET_USER_FAILED';

// Tipos para compras (unificados)
export const GET_PURCHASES_FOR_HISTORY = 'GET_PURCHASES_FOR_HISTORY';
export const LOADING_PURCHASES_HISTORY = 'LOADING_PURCHASES_HISTORY';

// Tipos para consumos (unificados)
export const GET_CONSUMPTIONS_FOR_HISTORY = 'GET_CONSUMPTIONS_FOR_HISTORY';
export const LOADING_CONSUMPTIONS_HISTORY = 'LOADING_CONSUMPTIONS_HISTORY';

export const GET_CREDIT_MOVEMENTS = 'GET_CREDIT_MOVEMENTS';
export const LOADING_CREDIT_MOVEMENTS = 'LOADING_CREDIT_MOVEMENTS';
export const SET_CREDIT_FILTERS = 'SET_CREDIT_FILTERS';